import React, { useEffect } from "react";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./components/Home";
import PlanLists from "./components/PlanList";
import ThankyouPage from "./components/ThankyouPage";
import PrivacyAndPolicy from "./components/PrivacyPolicy";
import { Navigation } from "./components/navigation";
import { Footer } from "./components/Footer";
import { CourseDrips } from "./components/courseDrips/CourseDrips";
import AboutUs from "./components/AboutUs";
import TermsAndConditions from "./components/TermsAndConditions";
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import whatsApplog from "../src/components/image/Image [header-logo].png";
import FreeResources from "./components/freeResources/FreeResources";
import DefaultModal from "./components/DefaultModal";
import { ClassRoomTestSeries } from "./components/ClassRoomDetails";
import FoundationPlanLists from "./components/FoundationPlanList";
import { SnackbarProvider } from 'notistack';
import BlogSection from "./components/freeResources/BlogSection";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {

  const RedirectToHomeWithRefresh = () => {
    useEffect(() => {
      window.location.replace("/");
    }, []);

    return null;
  };

  return (
    <React.Fragment>
      <SnackbarProvider maxSnack={3}>
        <Router>
          <Navigation />
          <DefaultModal />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/course-content" element={<CourseDrips />} />
            <Route path="/test-series" element={<PlanLists />} />
            <Route path="/foundation-test-series" element={<FoundationPlanLists />} />
            <Route path="/thankyou-page" element={<ThankyouPage />} />
            <Route path="/privacypolicy" element={<PrivacyAndPolicy />} />
            <Route path="/terms-condtion" element={<TermsAndConditions />} />
            <Route path="/aboutUs" element={<AboutUs />} />
            <Route path="/free-resouces" element={<FreeResources />} />
            <Route path="/classroom-courses" element={<ClassRoomTestSeries />} />
            <Route path="/blog" element={<BlogSection />} />
            <Route path="*" element={<RedirectToHomeWithRefresh />} />
          </Routes>
          <Footer />
          <FloatingWhatsApp avatar={'img/vsmartlogo.jpg'} phoneNumber={'+91-7887788725'} accountName="VSmart ExamPrep"
            chatMessage="Hello! How can I help you?" className="classcart-whatsapp-avatar" />
        </Router>
      </SnackbarProvider>
    </React.Fragment>
  );
};

export default App;
